module.exports = __webpack_public_path__ + "media/images/how_it_works/hiw-mobile-63289db0e3aeee9af43fbafad87a6ee4.jpg";